import { selectMaximizedStream } from 'features/layout/features/content/contentSlice';
import { useAppSelector } from 'store/hooks';

export const useIsCustomTileMaximized = (name: string) => {
  const maximizedStream = useAppSelector(selectMaximizedStream);

  return maximizedStream?.kind === 'custom' && maximizedStream.userId === name;
};
